"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AircraftCardInfo = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'reservation-aircraft';
class AircraftCardInfo extends react_1.default.PureComponent {
    render() {
        const { logo, name, company, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__logo` }, logo && (react_1.default.createElement("img", { src: logo, alt: name }))),
                react_1.default.createElement("div", { className: `${className}__content` },
                    react_1.default.createElement("div", { className: `${className}__name` }, name),
                    react_1.default.createElement("div", { className: `${className}__company` }, company)))));
    }
}
exports.AircraftCardInfo = AircraftCardInfo;
AircraftCardInfo.defaultProps = {
    logo: null,
    name: null,
    company: null,
};
//# sourceMappingURL=index.js.map